import { store } from "../store";
import { CultureEnum } from "./enum/CultureEnum";
import { CompanyTypeEnum } from "./enum/CompanyTypeEnum";

export function userIsAdmin() {
	const idCompanyType = store.getState().user.currentUser?.idCompanyType;
	return idCompanyType === CompanyTypeEnum.Admin;
}

export function userIsSupplier() {
	const idCompanyType = store.getState().user.currentUser?.idCompanyType;
	return idCompanyType === CompanyTypeEnum.Supplier;
}

export function userIsBodyshop() {
	const idCompanyType = store.getState().user.currentUser?.idCompanyType;
	return idCompanyType === CompanyTypeEnum.BodyShop;
}

export function userIsInsurer() {
	const idCompanyType = store.getState().user.currentUser?.idCompanyType;
	return idCompanyType === CompanyTypeEnum.Insurer;
}

export function userIsBuyer(guid: string) {
	const guidCompany = store.getState().user.currentUser?.guidCompany;
	return guidCompany === guid;
}

export function userUtcOffsetMilliseconds() {
	return store.getState().user.currentUser?.utcOffsetMilliseconds ?? 0;
}
export function userCompanyType() {
	return String(store.getState().user.currentUser?.idCompanyType);
}

/**
 * @description  Get IdCulture of User Logged
 * @returns {string}  Return IdCulture of User Logged
 * @example
 * const idCulture = getIdCultureUser();
 *
 * console.log(idCulture); // en-US
 */

export function getIdCultureUser() {
	const userReducer = store.getState().user;
	return userReducer.currentUser?.idCulture || CultureEnum.enUS;
}
